export const statusColorMappings = {
  EXPIRED: 'status status-red',
  FUTURE: 'status status-green',
  CURRENT: 'status status-blue',
};
